import React, { Component, Fragment } from "react";
import {
    rejectApplicant,
    approveApplicant
} from "../../../services/employerJobListing";
import AppContext from "../../../contexts/AppContext";
import RejectModal from "../jobListing/RejectModal";
import ApprovedModal from "../jobListing/ApprovedModal";

class List extends Component {
    state = {
        items: [{ user: {} }],
        meta: {},
        loading: true,
        showApproveModal: false,
        showRejectModal: false,
        id: 0
    };

    toggleApproveModal = id => {
        this.setState({
            id: id,
            showApproveModal: !this.state.showApproveModal
        });
    };
    toggleRejectModal = id => {
        this.setState({ id: id, showRejectModal: !this.state.showRejectModal });
    };

    rejectApplicant = () => {
        return rejectApplicant(this.state.id).then(response => {
            this.props.getItem();
            this.setState({
                showApproveModal: false,
                showRejectModal: false
            });
        });
    };

    approveApplicant = () => {
        return approveApplicant(this.state.id).then(response => {
            this.props.getItem(this.props.item.id);

            this.setState({
                showApproveModal: false,
                showRejectModal: false
            });
        });
    };

    render() {
        return (
            <Fragment>
                <tr>
                    <td>
                        <div className="row align-items-center">
                            <div className="col-auto">
                                <a href="">
                                    <img
                                        src={this.props.item.user.image}
                                        className="cc-image-lg rounded-circle"
                                        alt=""
                                    />
                                </a>
                            </div>
                            <div className="col ml-n2">
                                <h4 className="mb-1 name">
                                    {this.props.item.user.first_name}{" "}
                                    {this.props.item.user.last_name}
                                </h4>
                                <p className="small mb-0">
                                    {this.props.item.user.email}
                                </p>
                            </div>
                        </div>
                    </td>
                    <td>
                        <time datetime={this.props.item.created_at}>
                            {this.props.item.created_at}
                        </time>
                    </td>
                    <td className="text-right">
                        {this.props.item.state === "applied" ? (
                            <Fragment>
                                <button
                                    onClick={e =>
                                        this.toggleApproveModal(
                                            this.props.item.id
                                        )
                                    }
                                    type="button"
                                    className="btn btn-success btn-sm"
                                >
                                    Approve
                                </button>
                                <button
                                    type="button"
                                    onClick={e =>
                                        this.toggleRejectModal(
                                            this.props.item.id
                                        )
                                    }
                                    className="btn btn-danger btn-sm  ml-2"
                                >
                                    Reject
                                </button>
                            </Fragment>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-default btn-sm ml-2"
                            >
                                {this.props.item.state}
                            </button>
                        )}
                        {this.props.item.user.plan_id === 1 ? null : 
                        
                            <button
                                type="button"
                                className="btn btn-info btn-sm ml-2"
                            >
                                Message
                            </button>
                        }
                        
                        
                        {this.state.showApproveModal ? (
                            <ApprovedModal
                                approveApplicant={this.approveApplicant}
                                toggleApproveModal={this.toggleApproveModal}
                                item={this.props.item.item}
                            ></ApprovedModal>
                        ) : null}

                        {this.state.showRejectModal ? (
                            <RejectModal
                                toggleRejectModal={this.toggleRejectModal}
                                rejectApplicant={this.rejectApplicant}
                                item={this.props.item.item}
                            ></RejectModal>
                        ) : null}
                    </td>
                </tr>
            </Fragment>
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/employer/workSpace/List.js